import React, { useState } from 'react';
import { X, Info } from 'lucide-react';

const CreateClassTimetableModal = ({
  show,
  onClose,
  onCreate,
  availableClasses = [],
  availableSections = ['A', 'B', 'C', 'D'],
  bellSchedules = []
}) => {
  const [academicYear, setAcademicYear] = useState('2026-2027');
  const [selectedClass, setSelectedClass] = useState(availableClasses[0] || '6th Standard');
  const [selectedSection, setSelectedSection] = useState('A');
  const [selectedBellScheduleId, setSelectedBellScheduleId] = useState(bellSchedules[0]?.id || 'DEFAULT');

  if (!show) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate({
      academicYear,
      className: selectedClass,
      section: selectedSection,
      bellScheduleId: selectedBellScheduleId
    });
    onClose();
  };

  return (
    <div className="fs-modal-overlay" style={{ zIndex: 1200 }}>
      <div className="fs-modal-card" style={{ maxWidth: '460px', borderRadius: '16px', overflow: 'hidden' }}>
        
        {/* HEADER */}
        <div style={{
          padding: '18px 24px',
          borderBottom: '1px solid #E2E8F0',
          display: 'flex',
          justify: 'space-between',
          alignItems: 'center',
          backgroundColor: '#F8FAFC'
        }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#0F172A' }}>
              Create Class Timetable
            </h3>
            <div style={{ fontSize: '12.5px', color: '#64748B', marginTop: '2px' }}>
              Set up a new timetable draft for your class
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748B' }}>
            <X size={20} />
          </button>
        </div>

        {/* FORM BODY */}
        <form onSubmit={handleSubmit}>
          <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            
            {/* Academic Year */}
            <div>
              <label style={{ fontSize: '12.5px', fontWeight: '700', color: '#334155', marginBottom: '6px', display: 'block' }}>
                Academic Year *
              </label>
              <select
                className="form-control"
                value={academicYear}
                onChange={(e) => setAcademicYear(e.target.value)}
                style={{ height: '42px', borderRadius: '8px', fontSize: '13.5px', fontWeight: '600' }}
                required
              >
                <option value="2026-2027">2026–2027</option>
                <option value="2025-2026">2025–2026</option>
              </select>
            </div>

            {/* Class */}
            <div>
              <label style={{ fontSize: '12.5px', fontWeight: '700', color: '#334155', marginBottom: '6px', display: 'block' }}>
                Class / Grade *
              </label>
              <select
                className="form-control"
                value={selectedClass}
                onChange={(e) => setSelectedClass(e.target.value)}
                style={{ height: '42px', borderRadius: '8px', fontSize: '13.5px', fontWeight: '600' }}
                required
              >
                {availableClasses.map(cls => (
                  <option key={cls} value={cls}>{cls}</option>
                ))}
              </select>
            </div>

            {/* Section */}
            <div>
              <label style={{ fontSize: '12.5px', fontWeight: '700', color: '#334155', marginBottom: '6px', display: 'block' }}>
                Section *
              </label>
              <select
                className="form-control"
                value={selectedSection}
                onChange={(e) => setSelectedSection(e.target.value)}
                style={{ height: '42px', borderRadius: '8px', fontSize: '13.5px', fontWeight: '600' }}
                required
              >
                {availableSections.map(sec => (
                  <option key={sec} value={sec}>Section {sec}</option>
                ))}
              </select>
            </div>

            {/* School Period Schedule */}
            <div>
              <label style={{ fontSize: '12.5px', fontWeight: '700', color: '#334155', marginBottom: '6px', display: 'block' }}>
                School Period Schedule *
              </label>
              <select
                className="form-control"
                value={selectedBellScheduleId}
                onChange={(e) => setSelectedBellScheduleId(e.target.value)}
                style={{ height: '42px', borderRadius: '8px', fontSize: '13.5px', fontWeight: '600' }}
                required
              >
                <option value="DEFAULT">Regular School Day (8 Teaching Periods)</option>
                {bellSchedules.map(bs => (
                  <option key={bs.id || bs.scheduleId} value={bs.id || bs.scheduleId}>
                    {bs.scheduleName || 'Configured Period Schedule'}
                  </option>
                ))}
              </select>
            </div>

            {/* HELPER DISPLAY BADGE */}
            <div style={{
              backgroundColor: '#EFF6FF',
              border: '1px solid #BFDBFE',
              borderRadius: '10px',
              padding: '12px 14px',
              fontSize: '12.5px',
              color: '#1E40AF',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '8px'
            }}>
              <Info size={16} style={{ flexShrink: 0, marginTop: '2px' }} />
              <div>
                Subjects and assigned teachers will be loaded automatically from <strong>Subject Allocations</strong>.
              </div>
            </div>

          </div>

          {/* FOOTER */}
          <div style={{
            padding: '16px 24px',
            borderTop: '1px solid #E2E8F0',
            display: 'flex',
            justify: 'flex-end',
            gap: '10px',
            backgroundColor: '#F8FAFC'
          }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid #CBD5E1',
                backgroundColor: 'white',
                fontSize: '13px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                padding: '8px 20px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: '#2563EB',
                color: 'white',
                fontSize: '13px',
                fontWeight: '700',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)'
              }}
            >
              ✓ Create Timetable
            </button>
          </div>
        </form>

      </div>
    </div>
  );
};

export default CreateClassTimetableModal;
